// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import Container from './container';
import {DragDropContext} from 'react-dnd';
import {FormattedMessage} from 'react-intl';
import HTML5Backend from 'react-dnd-html5-backend';

/* eslint-disable babel/new-cap */

const DragAndDrop = props =>
    <div className='drag-and-drop'>
        <div className='available-items'>
            <label>
                <FormattedMessage id={props.availableItemsLabel}/>
            </label>
            <Container
                id='available-items'
                idAttribute={props.idAttribute}
                isDisplayValueMapped={props.isDisplayValueMapped}
                list={props.availableItems}
                mappingId={props.mappingId}
                mappingTable={props.mappingTable}
                onCardMove={props.onCardMove}
                onCardPush={props.onCardPush}
                onCardRemove={props.onCardRemove}
            />
        </div>
        <div className='selected-items'>
            <label className='asterisk-after'>
                <FormattedMessage id={props.selectedItemsLabel}/>
            </label>
            <Container
                id='selected-items'
                idAttribute={props.idAttribute}
                isDisplayValueMapped={props.isDisplayValueMapped}
                list={props.selectedItems}
                mappingId={props.mappingId}
                mappingTable={props.mappingTable}
                onCardMove={props.onCardMove}
                onCardPush={props.onCardPush}
                onCardRemove={props.onCardRemove}
            />
        </div>
    </div>;

DragAndDrop.displayName = 'DragAndDrop';
DragAndDrop.propTypes = {
    availableItems: PropTypes.array.isRequired,
    availableItemsLabel: PropTypes.string.isRequired,
    idAttribute: PropTypes.string.isRequired,
    isDisplayValueMapped: PropTypes.bool.isRequired,
    mappingId: PropTypes.string,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    onCardMove: PropTypes.func.isRequired,
    onCardPush: PropTypes.func.isRequired,
    onCardRemove: PropTypes.func.isRequired,
    selectedItems: PropTypes.array.isRequired,
    selectedItemsLabel: PropTypes.string.isRequired
};

export default DragDropContext(HTML5Backend)(DragAndDrop);

/* eslint-enable babel/new-cap */



// WEBPACK FOOTER //
// ./src/shared/components/drag-and-drop/index.js